export function formatBadgeCount(value: number) {
  return value > 99 ? "99+" : String(value);
}
